export function durationSecondsToString(duration: number): string {
  if (!duration || duration <= 0) {
    return '00:00';
  }

  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  return `${pad2(hours)}:${pad2(minutes)}`;
}

export function durationStringToSeconds(value: string): number {
  if (!value) {
    return 0;
  }

  const input = value.trim();
  const digitsOnly = input.replace(/\D/g, '');

  let hh = 0;
  let mm = 0;

  if (input.includes(':')) {
    const [hoursPart, minutesPart] = input.split(':');
    hh = parseInt(hoursPart, 10) || 0;
    mm = parseInt(minutesPart, 10) || 0;
  } else if (digitsOnly.length >= 3) {
    hh = parseInt(digitsOnly.slice(0, digitsOnly.length - 2), 10) || 0;
    mm = parseInt(digitsOnly.slice(-2), 10) || 0;
  } else {
    hh = parseInt(digitsOnly, 10) || 0;
  }

  hh = Math.max(0, Math.min(99, hh));
  mm = Math.max(0, Math.min(59, mm));

  return (hh * 3600) + (mm * 60);
}

function pad2(num: number): string {
  return (num < 10 ? '0' : '') + num;
}
